import React, { useContext, useEffect, useState } from 'react'

import Header from './Header'
import MicrocopyContext from '~contexts/MicrocopyContext'

const Component = ({
  showSearch
}) =>  {
  const microcopy = useContext(MicrocopyContext)
  const [searchEnabled, setSearchEnabled] = useState(false)

  useEffect(() => {
    setSearchEnabled(showSearch)
  }, [])

  return (
    <Header 
      microcopy={microcopy}
      searchEnabled={searchEnabled}
    />
  )
}

export default Component